export default __webpack_public_path__ + "static/media/logo.0a09ee57.png";